import { IS_LOCAL } from '../../constants';

export const getAuthConsts = (clientData) => {
  if (IS_LOCAL) {
    return {
      COOKIES_ROOT_DOMAIN: 'localhost',
      AUTH_DOMAIN: 'https://accounts.sportvot.com',
      OTT_URL: 'https://sportvot.com/tv',
    };
  }

  if (!clientData) return null;

  const { sso_subdomain_prefix, ott_subdomain_prefix, domain } = clientData;
  const authHost = sso_subdomain_prefix
    ? `${sso_subdomain_prefix}.${domain}`
    : domain;

  const ottHost = ott_subdomain_prefix
    ? `${ott_subdomain_prefix}.${domain}`
    : domain;

  return {
    COOKIES_ROOT_DOMAIN: `.${domain}`,
    AUTH_DOMAIN: `https://${authHost}`,
    OTT_URL: `https://${ottHost}/tv`,
  };
};

export default null;
